export enum TipoSedeEnum {
	SEDE_LEGALE = "SedeLegale",
	SEDE_OPERATIVA = "SedeOperativa",
	ALTRA_SEDE_OPERATIVA = "AltraSedeOperativa",
}
